import { FC } from 'react';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import List from 'antd/lib/form/FormList';

import ShippingByCountryHeader from 'components/Settings/PoliciesTab/ShippingByCountry/ShippingByCountryHeader';
import ShippingByCountryItem from 'components/Settings/PoliciesTab/ShippingByCountry/ShippingByCountryItem';
import { shippingValidator } from 'components/Settings/constants';
import { ShippingByCountryStyled, shippingTableClasses } from 'components/Settings/styled';
import { EPoliciesFields } from 'types/settings/enums';
import { IShippingPolicy } from 'types/settings/interfaces';

const ShippingByCountry: FC<IShippingPolicy> = ({ isShippingError, setIsShippingError }) => (
  <>
    <p className="required">Shipping time and policies</p>
    <Item className={`${shippingTableClasses} ${isShippingError ? 'border-red-50' : 'border-transparent'}`}>
      <List
        name={EPoliciesFields.Shipping}
        rules={[{ validator: (_, value) => shippingValidator(value, setIsShippingError) }]}
      >
        {(fields) =>
          <ShippingByCountryStyled>
            <ShippingByCountryHeader />
            {map(fields, ({ key }) => <ShippingByCountryItem key={key} fieldKey={key} />)}
          </ShippingByCountryStyled>}
      </List>
    </Item>
    <div className={`text-red-50 ${isShippingError ? 'block' : 'hidden'}`}>At least one Country should be selected</div>
  </>
);

export default ShippingByCountry;
